import React, { useEffect, useRef, useState } from "react";
import { GlobalStateProvider, useGlobalState } from "./GlobalStateProvider";
import { initAudioContext, playBGM } from "./SoundEffect";
import "./Title.css";

const Title: React.FC = () => {
  const { setCurrentStep } = useGlobalState();
  const turbulenceRef = useRef<SVGFETurbulenceElement>(null);
  const displacementRef = useRef<SVGFEDisplacementMapElement>(null);

  useEffect(() => {
    let animationFrameId: number;
    let startAnimate = new Date().getTime();

    const animate = () => {
      let newTime = new Date().getTime();
      const delta = newTime - startAnimate;
      if (turbulenceRef.current) {
        const freqX = 0// Math.sin(delta) + 1;
        const freqY = Math.cos(delta) + 1;
        turbulenceRef.current.setAttribute('baseFrequency', `${freqX} ${freqY}`);
      }
      if (displacementRef.current) {
        displacementRef.current.setAttribute('scale', `${Math.max((3000 - delta) / 500, 4)}`);
        displacementRef.current.setAttribute('in', Math.cos(delta / 47) + Math.cos(delta / 151) - 1 > 0 ? 'rgb-layers' : 'SourceGraphic');
      }
      animationFrameId = requestAnimationFrame(animate);

      if (delta > 9000) {
        setCurrentStep(11);
        cancelAnimationFrame(animationFrameId);
      }
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return <>
    <section id="title">
      <div id="title-wrapper">
        <img id="title-img" src={`${process.env.PUBLIC_URL}/img/title.webp`}></img>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
        <filter id="displacementFilter">
          <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" result="g" />
          <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 1 0 0 0 0 0 1 0" result="b" />
          <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feOffset dx="5" dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in="g" in2="" operator="lighter" />
          <feComposite in="b" in2="" operator="lighter" result="rgb-layers" />
          <feTurbulence ref={turbulenceRef} type="turbulence" baseFrequency="0 0" numOctaves="1" result="turb" />
          <feColorMatrix
            in="turb"
            type="matrix"
            values="
            1 -1 0 0 0.5
            0 1 -1 0 0.5
            -1 0 1 0 0.5
            0 0 0 1 1"
            result="centered"
          />
          <feDisplacementMap ref={displacementRef} in2="centered" in="rgb-layers"
            scale="4"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </svg>
    </section>
  </>;
};

export default Title;
